//eslint-disable-line
/*
_blank-search-suggestions.js

Requires jQuery

Handles JavaScript functionality for search term suggestions that show on certain
pages when the user is focused in a blank job title search field. JS-5594.
*/
(function($) {
  'use strict';

  // sets up blank search experience on a form
  var initBlankSearch = function($jobSearchForm) {
    var $window = $(window);
    var $body = $('body');

    var $search = $jobSearchForm.find('[name="search"]');
    var $location = $jobSearchForm.find('[name="location"]');
    var $searchSuggestions = $('[data-js-select="search_suggestions"]');
    var $searchLinks = $searchSuggestions.find('[data-js-select="search_keyword"]');
    var $exploreSERPCTA = $searchSuggestions.find('[data-js-select="explore_cta_serp"]');
    var $suggestedJobsLandedFrom = $jobSearchForm.find('[name="landed_from"]');
    var $exploreSuggestedJobsCTA = $searchSuggestions.find('[data-js-select="explore_cta_sj"]');

    // so _job-results-header.js & _job-search.js can hide the suggestions when needed
    $window.on('job_search_form_hide', function() {
      hideSuggestions();
    });

    // hide suggestions
    var hideSuggestions = function() {
      $body.removeClass('search_suggestions_open');
    };

    // show suggestions
    var showSuggestions = function () {
      $body.addClass('search_suggestions_open');
    };

    // determine if submitting the search form will load a new page
    var stayingOnCurrentPage = function ($jobSearchForm, windowLocation) {
      // if not on SERP we will load a new page
      if (windowLocation.pathname !== '/candidate/search') { return false; }

      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
      // jQuery serialize() does not encode per RFC 3986 (which reserves !, ', (, ), and *)
      var encodedFormData = $jobSearchForm.serialize().replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16);
      });

      // if already on SERP and the search will not change when the form is submitted, we will stay on the current page
      return (windowLocation.search.substring(1) === encodedFormData);
    };

    // reset the value to prevent cacheing
    if ($exploreSuggestedJobsCTA) {
      $suggestedJobsLandedFrom.val('suggested_jobs_blank_search');
    }

    // clicks on search links submit the search form
    $searchLinks.on('click', function(e) {
      var searchTerm = $(this).data('search-term');
      e.preventDefault();
      $search.val(searchTerm);

      if ($exploreSERPCTA) {
        $jobSearchForm.append('<input type="hidden" name="landed_from" value="serp_explore_cta" />');
      }

      if ($exploreSuggestedJobsCTA) {
        $suggestedJobsLandedFrom.val('suggested_jobs_explore_cta');
      }

      $('.search_input_wrapper').addClass('filled'); // for desktop: so we don't have to wait for floatlabels to catch up

      // if the form submit will not load a new page, hide the suggestions
      if (stayingOnCurrentPage($jobSearchForm, window.location)) {
        // hide search form and suggestions via click on Close button (will cause hideSuggestions to execute)
        $('.job_search_hide').trigger('click');
      }

      // update intsrc of form if they used a search link
      var originalAction = $jobSearchForm.attr('action');

      if (!originalAction.includes('helper_links')) {
        var newAction = originalAction.replace('.serp_form', '.helper_links.serp_form');
        $jobSearchForm.attr('action', newAction);
      }

      $jobSearchForm.submit();
    });

    // show search suggestions when they focus on the job title search field & it is empty
    $search.on('focus', function() {
      if (!$search.val()) {
        showSuggestions();
      }
    });

    // Hide suggestions if they make it to the location field
    $location.on('focus', function() {
      hideSuggestions();
    });

    $jobSearchForm.on('submit', function() {
      // if the form submit will not load a new page, hide search form and suggestions via click on Close button
      if (stayingOnCurrentPage($jobSearchForm, window.location)) {
        $('.job_search_hide').trigger('click');
      }
    });

    $search.attr('autocomplete', 'off'); // so browser autocomplete does not compete with suggestions

    // hide search suggestions once they start typing in search field
    $search.on('input', function() {
      if ($search.val()) {
        hideSuggestions();
      } else {
        // search field has no value -> they backspaced to empty search field
        showSuggestions();
        $search.attr('autocomplete', 'off'); // so browser autocomplete does not compete with suggestions
      }
    });
  }; // end initBlankSearch

  // only show blank search suggestions on certain forms
  var $jobSearchForms = $('.job_search_form');
  $jobSearchForms.each(function () {
    var $form = $(this);
    if (!$form.data('noBlankSearch')) {
      initBlankSearch($form);
    }
  });
}(window.jQuery));
